export default __webpack_public_path__ + "b3a54733b5bdea979c9fc8bd81cb6d99.png";